import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const iconTone: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function CategoryEntries() {
  const entries = [
    ...categories,
    {
      type: "works",
      name: "影视作品",
      shortName: "作品",
      description: "按类型与年份浏览她参演的全部影视作品。",
      icon: "ri-film-line",
      color: "primary",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {entries.map((item) => {
        const to = item.type === "works" ? "/works" : `/category/${item.type}`;
        return (
          <Link
            key={item.type}
            to={to}
            className="group flex flex-col items-start gap-3 bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50/50 transition-colors cursor-pointer"
          >
            <span
              className={`w-11 h-11 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${iconTone[item.color]}`}
            >
              <i className={`${item.icon} text-xl md:text-2xl`}></i>
            </span>
            <div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                {item.shortName}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                {item.description}
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}